<div>
  <app-european-trend-filters *ngIf="years && categories && countries"
    [years]="years"
    [countries]="countries"
    [categories]="categories"
    [countryCategory]="countryCategory"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)">
  </app-european-trend-filters>
  <mat-divider></mat-divider>
  <app-european-trend-bar-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [countryCategory]="countryCategory"
    [countries]="dataCountries"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-european-trend-bar-chart>
</div>
